import React, { useEffect, useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

import Script from "next/script";

const Contact = ({ blok }) => {
  const [successBox, setSuccessBox] = useState("none");

  const createFormCT = () => {
    Formio.createForm(
      document.getElementById("contactForm"),
      "https://forms.erfolgreichgastro.de/#/form/68387b4d0a62bbeccef9b363/",
      {
        hooks: {
          customValidation: async (submission, next) => {
            const submissionData = JSON.stringify(submission.data);

            if (submissionData.includes("<") || submissionData.includes(">")) {
              console.error(
                "Fehler beim Validieren des Formulars auf dem Server."
              );
              alert("Folgende Zeichen sind nicht erlaubt: <, >");
            } else {
              next();
            }
          },
        },
      }
    ).then(function (form) {
      /*  form.on("render", function () {
        const selectField = form.getComponent("chooseContactPartner");
        const selectFieldLabel = document.querySelector(".col-form-label");

        if (
          window.location ==
            "https://hpew.datenwerk.dev/contact-stern-der-gastlichkeit/" ||
          window.location ==
            "http://localhost:3000/contact-stern-der-gastlichkeit/" ||
          window.location ==
            "https://www.erfolgreichgastro.de/contact-stern-der-gastlichkeit/"
        ) {
          selectFieldLabel.style.display = "none";
          selectField.setValue("Stern der Gastlichkeit");
          selectField.disabled = true;
        }
      }); */

      form.on("submit", function (submission) {
        showSuccessBox();
        gtag("event", "Formular_abgesendet", {
          event_category: "Formular_abgesendet",
        });

        _paq.push(["trackEvent", "Formular", "Formular_abgesendet"]);
      });
    });
  };

  /*   useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.form.io/formiojs/formio.form.min.js";
    script.onload = createFormCT;
    document.body.appendChild(script);
  }, []); */

  useEffect(() => {
    createFormCT();
  }, []);

  function showSuccessBox() {
    setSuccessBox("flex");
  }

  function newSubmit() {
    location.reload();
  }

  return (
    <div className="textWithContact-wrap" {...storyblokEditable(blok)}>
      <div className="textWithContact-contentOuter">
        <div className="textWithContact-contentLeft">
          <h2 className="textWithContact-headline text-5xl">{blok.headline}</h2>

          <p className="textWithContact-introtext">{blok.introText}</p>
          <p className="textWithContact-introtext2"> {blok.introText2}</p>

          <div className="textWithContact-partnerContentOuter">
            <div className="textWithContact-partnerContentInner">
              <div className="textWithContact-partnerContentImage">
                <img
                  src={blok.partnerImage.filename}
                  alt={blok.partnerImage.alt}
                />
              </div>

              <div>
                <div>
                  <span className="textWithContact-partnerContentHeadline">
                    {blok.partnerHeadline}
                  </span>
                </div>

                <div>
                  <h2 className="textWithContact-partnerContentName text-5xl">
                    {blok.partnerName}
                  </h2>
                </div>
              </div>
            </div>

            <a href="tel:+4915257966440">
              <div className="textWithContact-partnerContentPhone">
                <img
                  className="imgtextleft-image"
                  src="/src/icons/phone.png"
                  alt=""
                />

                <span>{blok.partnerPhone}</span>
              </div>
            </a>

            <a href="mailto:erfolgreichgastro@paulaner-gruppe.de">
              <div className="textWithContact-partnerContentMail">
                <img
                  className="imgtextleft-image"
                  src="/src/icons/mail.png"
                  alt=""
                />
                <span>{blok.partnerMail}</span>
              </div>
            </a>
          </div>
        </div>

        <div className="textWithContact-hrline"></div>

        <div className="textWithContact-contentRight">
          <div className="contact">
            <div id="contactForm"></div>
            <div
              style={{ display: `${successBox}` }}
              className="success-box-ct"
            >
              <div>
                <p>Ihre Anfrage wurde erfolgreich an uns gesendet.</p>
                <p>Vielen Dank für Ihre Kontaktaufnahme.</p>
                <button onClick={newSubmit}>Weitere Anfrage stellen</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="textWithContact-contentBottom">
        <div className="textWithContact-contentBottomButton">
          <div className="textWithContact-contentBottomHeadline">
            <span>{blok.bottomHeadline}</span>
          </div>

          <div className="textWithContact-buttonOuter">
            <div>
              {blok.bottomButton && (
                <Link href={blok.bottomLink} >
                  <button>{blok.bottomButton}</button>
                </Link>
              )}
              {blok.bottomButtonnewtab && (
                <Link target="_blank" href={blok.bottomLinknewtab} >
                    <button>{blok.bottomButtonnewtab}</button>
                </Link>
              )}
            </div>
          </div>
        </div>

        <div className="textWithContact-contentBottomImage">
          <img src={blok.bottomImage.filename} alt={blok.bottomImage.alt} />
        </div>
      </div>
    </div>
  );
};

export default Contact;
